import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { CompareResults } from "../../../queries/useBuildComparison";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { useDealerAccountInfo } from "../../../stores/hooks/useDealerAccountInfo";

type ProductInfoProps = {
  className?: string;
  part: TirePartItem | null;
};

export const hasWarranty = (visibleResults?: CompareResults[]): boolean => {
  const result =
    visibleResults?.some(
      ({ part }) => part.partDetails.primaryPart.tireWarrantyList.length > 0
    ) ?? false;
  return result;
};

export const Warranty: FunctionComponent<ProductInfoProps> = ({
  className,
  part,
}) => {
  const { t } = useTranslation();
  const { dealerCountry } = useDealerAccountInfo();
  const [language] = useLanguage();

  const warranty = part?.partDetails.primaryPart.tireWarrantyList.find(
    ({ warrantyCountryCode, warrantyLanguageCode }) =>
      warrantyCountryCode.toLowerCase() === dealerCountry.toLowerCase() &&
      warrantyLanguageCode.toLowerCase() === language.toLowerCase()
  );

  return (
    <div className={clsx(className, "text-xs")}>
      {warranty ? (
        <>
          {warranty.warrantyText}{" "}
          {warranty.warrantyUrl && (
            <a
              className="underline text-primary print:hidden"
              href={warranty.warrantyUrl}
              rel="noreferrer"
              target="_blank"
            >
              {t("compare.moreInfo")}
            </a>
          )}
        </>
      ) : (
        t("compare.notAvailable")
      )}
    </div>
  );
};
